var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcLoudSpeakerCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 2.252c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10Zm5 6.368a1 1 0 0 0-1.303-.953l-9 2.864a1 1 0 0 0-.697.952v1.538c0 .436.282.822.697.954L9 14.707v3.155c0 .23.157.43.379.486l1 .25a.5.5 0 0 0 .621-.486v-2.77l4.697 1.496A1 1 0 0 0 17 15.885V8.62Z",
  fill: "#FFC700"
})));
export default SvgIcLoudSpeakerCircle;